import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  payOrder: [
    'code',
    'orderId',
    'transactionId',
    'email',
    'payMethod',
    'brand',
    'message'
  ],
  // Reducer
  payOrderClear: null,
  payOrderRequest: null,
  payOrderSuccess: null,
  payOrderFailure: ['error']
});

export { Creators, Types };
